import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getIsLoading, selectScoreRanges } from '../../store/slice'
import {
  getScoreRangesCreditRisk,
  getScoreRangesPerformance,
} from '../../store/thunk'

const colorIndex = (range, score) => {
  return range.find(
    (range) => score >= range.scoreRange_Min && score <= range.scoreRange_Max,
  )
}

const getRangeById = (range, id) => {
  return range.find((item) => item?.scoreRangeId === id)
}

export const UseScoreRange = (isDisableApi = false, val, idScore) => {
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)
  const loading = useSelector(getIsLoading('score'))
  const data = useSelector(selectScoreRanges)

  useEffect(() => {
    if (isDisableApi) return
    dispatch(getScoreRangesCreditRisk({ NeedUndetermine: true }))
    dispatch(getScoreRangesPerformance({ NeedUndetermine: true }))
  }, [locale])

  return {
    loading,
    data,
    creditRange: colorIndex(data.CREDIT_RISK, val),
    perRange: colorIndex(data.PERFORMANCE, val),
    creditRangeById: getRangeById(data.CREDIT_RISK, idScore),
    perRangeById: getRangeById(data.PERFORMANCE, idScore),
  }
}
